import { useEffect, useState } from "react";
// @mui
import {
  Card,
  Stack,
  Typography,
} from "@mui/material";
// sections
import {
  NoTrackingRecord,
  TrackingRecordTable,
  TrackingRecordList,
} from "./";
// hooks
import useResponsive from '../../hooks/useResponsive';
import useLocalStorage from '../../hooks/useLocalStorage';

// ----------------------------------------------------------------------

export default function TimeTrackingRecords ({ crewId, totalCount, trackingData, openFromAlimtalk=null }) {
  const smUp = useResponsive('up', 'sm');

  const [lastId, setLastId] = useLocalStorage(`dioBizCrew${crewId}TimeId`, 0);
  const [lastReadId, setLastReadId] = useState(0);

  useEffect(() => {
    if ((trackingData?.length > 0) && lastId < trackingData[0]?.id) {
      setLastId(trackingData[0]?.id);
    }
    setLastReadId(lastId);
  }, []);

  return (
    <Stack spacing={3}>
      <Typography variant="h5">
        근무 기록 {totalCount}건
      </Typography>

      {trackingData?.length === 0 && (
        <NoTrackingRecord />
      )}
      <Card>
        {trackingData?.length > 0 && smUp && (
          <TrackingRecordTable lastId={lastReadId} trackingData={trackingData} openFromAlimtalk={openFromAlimtalk} />
        )}
        {trackingData?.length > 0 && !smUp && (
          <TrackingRecordList lastId={lastReadId} trackingData={trackingData} openFromAlimtalk={openFromAlimtalk} />
        )}
      </Card>
    </Stack>
  )
}
